import { Box, Grid } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";


function Banners() {


    const [banners, setBanners] = useState(null);
     
    useEffect(() => {
        axios.get('/api/banners?active.equals=true')
        .then((res) => {
            setBanners(res.data?.filter(b => b.text != 'fobanner'))
        }).catch((err) => console.log('err', err))
    }, [])

    return (
        <Grid spacing={2} container>
            {banners?.map((b, bKey) => <Grid key={bKey} xs={12} md={4} item>
                <Box sx={{ 
                    width: '100%',
                    height: '30vh',
                    bgcolor: '#999',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundImage: `url('data:${b.imageContentType};base64,${b.image}')` }}>

                </Box>
            </Grid>)}
        </Grid>
    );
}

export default Banners;
